import FormInput from 'components/FormInput/FormInput';
import useStateStore from 'services/store';

const sendSamples = [
  {
    id: 'phone-number',
    name: 'phone',
    placeHolder: 'Phone',
  },
  {
    id: 'any-remarks',
    name: 'any-remarks',
    placeHolder: 'Any Remarks',
  },
];

const SendSample = () => {
  const { inforStep } = useStateStore();
  return renderInfor(inforStep);
};

const renderInfor = (inforFlow: number) => {
  switch (inforFlow) {
    case 1:
      return <SampleShirtForm />;
    default:
      return <SampleShirtForm />;
  }
};

const SampleShirtForm = () => {
  const { changeInforInputValues, inforInputValues: inputValues } =
    useStateStore();

  return (
    <div className="body-container">
      <form className="personal-detail-form">
        {sendSamples.map((sample) => (
          <FormInput
            key={sample.id}
            label={sample.name.toUpperCase()}
            id={sample.id}
            name={sample.name}
            placeholder={sample.placeHolder}
            value={inputValues?.[sample.id]}
            onChange={(e) => changeInforInputValues(sample.id, e.target.value)}
          />
        ))}
      </form>
    </div>
  );
};

export default SendSample;
